import { Component, OnInit } from '@angular/core';
import { FeaturePackResource } from 'angular/resources/feature-pack.resource';
import { FeaturePackGroupResource } from 'angular/resources/feature-pack-group.resource';
import { forkJoin } from 'rxjs';
import { SubscriptionGroup } from 'angular/operator-settings/SubscriptionGroup';
import { Growl } from 'angular/custom/services/growl.service';

@Component({
    selector: 'pkp-tso-subscriptions',
    template: require('./tso-subscriptions.component.html')
})
export class TsoSubscriptionsComponent implements OnInit {
    subscriptionGroups: SubscriptionGroup[] = [];

    state: 'LOADING' | 'ERROR' | 'LOADED' = 'LOADING';

    constructor(
        private featurePackResource: FeaturePackResource,
        private featurePackGroupResource: FeaturePackGroupResource,
        private growl: Growl
    ) {}

    public ngOnInit(): void {
        this.featurePackResource.get().subscribe(
            (featurePacks: FeaturePackDto[]) => {
                let groupIds: Set<number> = new Set<number>();

                featurePacks
                    .map((pack) => pack.groupIds)
                    .reduce((flatten, arr) => [...flatten, ...arr]) //can be replaced with flat() in newer core-js versions
                    .forEach((id) => groupIds.add(id));

                forkJoin(
                    Array.from(groupIds).map((groupId) =>
                        this.featurePackGroupResource.get(groupId)
                    )
                ).subscribe(
                    (featurePackGroups: FeaturePackGroupDto[]) => {
                        featurePackGroups.sort(function (a, b) {
                            return a.order - b.order;
                        });
                        let featurePacksGroupedByFeaturePackGroup =
                            this.groupByFeaturePackGroup(featurePacks);
                        this.subscriptionGroups = this.mapSubscriptionGroups(
                            featurePackGroups,
                            featurePacksGroupedByFeaturePackGroup
                        );

                        //Remove SSO feature packs for now
                        this.subscriptionGroups =
                            this.subscriptionGroups.filter(
                                (item) => item.name !== 'Basic SSO'
                            );
                        this.subscriptionGroups =
                            this.subscriptionGroups.filter(
                                (item) => item.name !== 'SSO Add-on'
                            );

                        this.state = 'LOADED';
                    },
                    () => {
                        this.growl.show(
                            'Loading of subscription-groups failed.',
                            'danger'
                        );
                        this.state = 'ERROR';
                    }
                );
            },
            () => {
                this.growl.show('Loading of subscriptions failed.', 'danger');
                this.state = 'ERROR';
            }
        );
    }

    private mapSubscriptionGroups(
        featurePackGroups: FeaturePackGroupDto[],
        featurePacksGroupedByFeaturePackGroup: { [p: number]: FeaturePackDto[] }
    ) {
        return featurePackGroups.map(
            (featurePackGroup: FeaturePackGroupDto) => {
                return {
                    name: featurePackGroup.name,
                    description: featurePackGroup.description,
                    subscriptions: this.mapToSubscriptions(
                        featurePacksGroupedByFeaturePackGroup[
                            featurePackGroup.id
                        ]
                    )
                };
            }
        );
    }

    private mapToSubscriptions(featurePacks: FeaturePackDto[]) {
        return featurePacks.map((pack) => {
            return {
                service: pack.name,
                subscribed: pack.subscribed,
                link:
                    pack.documentationLinks.length > 0
                        ? pack.documentationLinks[0]
                        : undefined
            };
        });
    }

    private groupByFeaturePackGroup(featurePacks: FeaturePackDto[]): {
        [groupId: number]: FeaturePackDto[];
    } {
        let result: { [groupId: number]: FeaturePackDto[] } = {};

        featurePacks.forEach((pack) => {
            pack.groupIds.forEach((groupId) => {
                if (result[groupId]) {
                    result[groupId].push(pack);
                } else {
                    result[groupId] = [pack];
                }
            });
        });

        return result;
    }
}
